export const ReviewData = [
  {
    id: '1',
    date: '28 Sep 2023',
    customer1: {
      name: 'John Smith',
      image: '/assets/img/customer/user-01.jpg',
    },
    customer2: {
      name: 'Sharon',
      image: '/assets/img/customer/user-03.jpg',
    },
    service: {
      name: 'Computer Repair',
      image: '/assets/img/services/service-03.jpg',
    },
    status: 'Normal',
    rating: '5.0',
    review: 'New test',
  },
  {
    id: '2',
    date: '10 Sep 2023',
    customer1: {
      name: 'Johnny',
      image: '/assets/img/customer/user-04.jpg',
    },
    customer2: {
      name: 'Pricilla',
      image: '/assets/img/customer/user-05.jpg',
    },
    service: {
      name: 'Car Repair Services',
      image: '/assets/img/services/service-02.jpg',
    },
    status: 'Normal',
    rating: '4.5',
    review: 'Review testing',
  },
  {
    id: '3',
    date: '25 Sep 2023',
    customer1: {
      name: 'Robert',
      image: '/assets/img/customer/user-06.jpg',
    },
    customer2: {
      name: 'Amanda',
      image: '/assets/img/customer/user-02.jpg',
    },
    service: {
      name: 'Steam Car Wash',
      image: '/assets/img/services/service-04.jpg',
    },
    status: 'High',
    rating: '4.9',
    review: 'New test',
  },
  {
    id: '4',
    date: '08 Sep 2023',
    customer1: {
      name: 'Sharonda',
      image: '/assets/img/customer/user-09.jpg',
    },
    customer2: {
      name: 'James',
      image: '/assets/img/customer/user-09.jpg',
    },
    service: {
      name: 'House Cleaning',
      image: '/assets/img/services/service-09.jpg',
    },
    status: 'Excellent',
    rating: '5.0',
    review: 'Review testing',
  },
  {
    id: '5',
    date: '28 Sep 2023',
    customer1: {
      name: 'John Smith',
      image: '/assets/img/customer/user-01.jpg',
    },
    customer2: {
      name: 'Sharon',
      image: '/assets/img/customer/user-03.jpg',
    },
    service: {
      name: 'Computer Repair',
      image: '/assets/img/services/service-03.jpg',
    },
    status: 'Normal',
    rating: '5.0',
    review: 'New test',
  },
  {
    id: '6',
    date: '10 Sep 2023',
    customer1: {
      name: 'Johnny',
      image: '/assets/img/customer/user-04.jpg',
    },
    customer2: {
      name: 'Pricilla',
      image: '/assets/img/customer/user-05.jpg',
    },
    service: {
      name: 'Car Repair Services',
      image: '/assets/img/services/service-02.jpg',
    },
    status: 'Normal',
    rating: '4.5',
    review: 'Review testing',
  },
  {
    id: '7',
    date: '25 Sep 2023',
    customer1: {
      name: 'Robert',
      image: '/assets/img/customer/user-06.jpg',
    },
    customer2: {
      name: 'Amanda',
      image: '/assets/img/customer/user-02.jpg',
    },
    service: {
      name: 'Steam Car Wash',
      image: '/assets/img/services/service-04.jpg',
    },
    status: 'High',
    rating: '4.9',
    review: 'New test',
  },
  {
    id: '8',
    date: '08 Sep 2023',
    customer1: {
      name: 'Sharonda',
      image: '/assets/img/customer/user-09.jpg',
    },
    customer2: {
      name: 'James',
      image: '/assets/img/customer/user-09.jpg',
    },
    service: {
      name: 'House Cleaning',
      image: '/assets/img/services/service-09.jpg',
    },
    status: 'Excellent',
    rating: '5.0',
    review: 'Review testing',
  },
];
